import {
  ListFeaturesItemProps,
  ListFeaturesItemVariant,
} from '../components/ListFeatures/components/ListFeaturesItem';

const TESTED_FEATURE_VARIANTS: ListFeaturesItemVariant[] = ['ready', 'damaged'];

/**
 * Only equipment recorded as functional or non-functional was actually tested. Unavailable,
 * untested and unfilled items carry no verdict, so they must not turn the section flag green.
 */
export const isFeatureTested = (feature: Pick<ListFeaturesItemProps, 'variant'>) =>
  TESTED_FEATURE_VARIANTS.includes(feature.variant);
